import React, { useContext, useEffect, useState } from 'react'
import Tables from './Table'
import DashboardMessage from '../components/DashboardMessage'
import useFetch from '../customHooks/useFetch'
import Loader from '../components/Loader';
import config from "../services/config.json";
import { MenuActive } from '../context/MenuActiveContext';
import { useSearchParams } from 'react-router-dom';

const VenderList = () => {
  const {loading,data} = useFetch("getVendor")
  const [vendorData, setVendorData] = useState("");
  const { setMunuActiv } = useContext(MenuActive);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if(data) {
      setMunuActiv([true,"VendorManagement"])
      setVendorData(data?.data)
    }
  }, [data,setMunuActiv]);

  const filterIndex = searchParams.get("tab") || "active";
  const currentPage = Number(searchParams.get("page") || 1);
  const filterData = [
    {
      label: "active"
    },
    {
      label: "hold"
    },
    {
      label: "request"
    },
  ];
  const handleFilter = (item) => {
    setSearchParams({ tab: item });
  }

  const handlePageChange = (page) => {
    const nextParams = { tab: filterIndex };
    if (page > 1) nextParams.page = String(page);
    setSearchParams(nextParams);
  }

  if(loading) return <Loader />;

  return (
    <>
    <DashboardMessage   data={{
    button: {
      label: "Add New Vendor",
      link: `/${config.demo}vendor/create`
    }
  }} />
   <div className="orderPage">
    <div className="orderPage_top mt-5 flex justify-between">
          <div className="orderPage_topl">
            <ul className="list flex gap-3">
              {
                filterData.map((item,index) => {
                  return (
                    <li className={filterIndex === item.label ? "active" : ""} key={index} onClick={() => handleFilter(item.label)}>{item.label}</li>
                  )
                })
              }
            </ul>
          </div>
        </div>
  {vendorData && <Tables datass={vendorData[filterIndex]} tabdrop={filterData} tab={filterIndex} update={setVendorData} currentPage={currentPage} onPageChange={handlePageChange} />}


   </div>
    </>
  )
}

export default VenderList





